/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type DmpRetrievalContext from 'parog-web/contexts/dmp-retrieval-context';

export default <template>
  <div class='ui info icon message'>
    <i class='notched circle loading icon'></i>
    <div class='content'>
      <div class='header'>Chargement en cours…</div>
      {{#if (has-block 'title')}}
        {{! @glint-expect-error }}
        {{yield to='title'}}
      {{else}}
        {{t
          (concat
            'cnam-services-access-form.loading.' @context.currentState.key
          )
          default='cnam-services-access-form.loading.other'
        }}
      {{/if}}
      {{#if (has-block 'content')}}
        <br />
        {{! @glint-expect-error }}
        {{yield to='content'}}
      {{/if}}
      <br />
      Cette étape peut durer quelques dizaines de secondes, veuillez patienter.
    </div>
  </div>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    context: DmpRetrievalContext;
    onDismiss: () => void;
  };
}>;
